/* eslint-disable react/prop-types */
import { Component } from "react"
import PropTypes from "prop-types"
import FormNew from "./form_new"
import FormsList from "./forms_list"
import { pluralize } from "utils/helpers"
import { Router } from "@reach/router"
import { Pane } from "components/ui"
import { Box, Button, Text } from "@planningcenter/tapestry-react"
import { colors } from "components/shared/admin_colors"

class FormsIndex extends Component {
  constructor(props) {
    super(props)

    this.state = { forms: props.forms || [] }

    this.handleNewFormSubmit = this.handleNewFormSubmit.bind(this)
  }

  handleNewFormSubmit(form) {
    this.setState(prevState => ({
      forms: [...prevState.forms, form]
    }))
  }

  render() {
    const {
      blankStateImageURL,
      peopleForms,
      event,
      routerBasePath,
      questionsIndexPath
    } = this.props

    const { forms = [] } = this.state

    const basePath = `${routerBasePath}events/${event.id}/forms`

    const attendeeQuestionsUrl = `${routerBasePath}events/${event.id}/collect/attendee_questions`

    return (
      <Router basepath={basePath}>
        <New
          path={`/new`}
          basePath={basePath}
          onSubmit={this.handleNewFormSubmit}
          peopleForms={peopleForms}
          event={event}
        />
        <List
          path={"/"}
          basePath={basePath}
          default={true}
          forms={forms}
          blankStateImageURL={blankStateImageURL}
          questionsIndexPath={questionsIndexPath}
          attendeeQuestionsUrl={attendeeQuestionsUrl}
          event={event}
        />
      </Router>
    )
  }
}

FormsIndex.defaultProps = {
  blankStateImageURL: "/static/blank-states/registrations-forms.svg"
}

FormsIndex.propTypes = {
  forms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      key: PropTypes.string,
      name: PropTypes.string,
      remote_url: PropTypes.string
    })
  ),
  blankStateImageURL: PropTypes.string.isRequired,
  showNewForm: PropTypes.bool
}

const New = ({ navigate, basePath, event, peopleForms, onSubmit }) => {
  const handleSubmit = form => {
    onSubmit(form)
    navigate(basePath)
  }
  return (
    <FormNew
      onSubmit={handleSubmit}
      onCancel={() => navigate(basePath)}
      peopleForms={peopleForms}
      event={event}
    />
  )
}

const List = ({ basePath, forms, navigate, questionsIndexPath, attendeeQuestionsUrl }) => {
  return (
    <Pane id="forms-list">
      <Pane.Header wrap="wrap">
        <h1 css={{ whiteSpace: "nowrap" }} className="h2 mb-0">
          {pluralize("form", "forms", forms.length + 1)}{" "}
        </h1>
        <Button
          title="New form"
          theme="create"
          onClick={() => navigate(`${basePath}\\new`)}
          marginTop={1}
          mediaQueries={{ sm: { marginTop: 0 } }}
        />
      </Pane.Header>
      <FormsList forms={forms} questionsIndexPath={questionsIndexPath} />
      <Pane.Footer>
        <Box padding={2} width="100%" borderTop="1px solid var(--pane--border-color)">
          <Text color={colors.neutral_030} size={14}>
            Forms are used to collect additional information from attendees after they register.
            Need to ask questions before registration is complete? Consider using{" "}
            <a href={attendeeQuestionsUrl}>Attendee Questions.</a>
          </Text>
        </Box>
      </Pane.Footer>
    </Pane>
  )
}

export default FormsIndex
